import React, { useEffect, useState } from "react";
import TitleComp from "../components/Title/title";
import TableComp from "../components/table/tables";
import DrawerComp from "../components/Drower/Drawer";
import moment from "moment";
import axios from "axios";
import { useDrawer } from "../context/drawer";
import { Button, Tag, message, Popconfirm } from "antd";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import qs from 'qs'; // Import qs library for x-www-form-urlencoded

export default function Blog() {
  const [fetchList, setFetchList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageComp, setPageComp] = useState(1);
  const [limitComp, setLimitComp] = useState(10);
  const [totalData, setTotalData] = useState(null);
  const { setDrawerData, drawerData } = useDrawer();

  const handleDrawerUpdate = (record) => {
    setDrawerData({
      ...drawerData,
      isOpen: true,
      type: "blogEdit",
      title: "Edit Blog",
      data: record,
      onSuccess: () => fetchData(pageComp, limitComp),
    });
  };

  const removeProperty = async (blogId) => {
    console.log("Attempting to delete blog with ID:", blogId); // Log the ID being sent
    try {
      setLoading(true);

      // Data to be sent in x-www-form-urlencoded format
      const postData = {
        action: 'delete_blog',
        id: blogId
      };

      // --- MODIFIED LINE: Send data in x-www-form-urlencoded format in the request body ---
      const resp = await axios.delete(
        'https://skdm.in/server/sdg/blogs.php',
        {
          data: qs.stringify(postData), // Convert object to x-www-form-urlencoded string
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }
      );
      // -------------------------------------------------------------------------------------

      console.log("Delete API response:", resp); // Log the full response

      if (resp?.data?.status === "success" || resp.status === 200) {
        message.success("Blog deleted successfully!");
        fetchData(pageComp, limitComp); // Re-fetch data to update the table
      } else {
        message.error(resp?.data?.message || "Failed to delete blog. Server error.");
      }
    } catch (error) {
      console.error("Error deleting blog:", error);
      if (axios.isAxiosError(error)) {
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          message.error(`Failed to delete blog: ${error.response.data.message || 'Server responded with an error.'}`);
        } else if (error.request) {
          console.error("Error request:", error.request);
          message.error("Failed to delete blog: No response from server. Check network.");
        } else {
          console.error("Error message:", error.message);
          message.error(`Failed to delete blog: ${error.message}`);
        }
      } else {
        message.error(`An unexpected error occurred: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      ellipsis: true,
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      ellipsis: true,
    },
    {
      title: "Short Description",
      dataIndex: "short_description",
      key: "short_description",
      render: (text) => (
        <div
          title={text}
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 200,
          }}
        >
          {text}
        </div>
      ),
    },
    // {
    //   title: "Content",
    //   dataIndex: "content",
    //   key: "content",
    //   render: (value) => (
    //     <div
    //       dangerouslySetInnerHTML={{ __html: value }}
    //       style={{
    //         whiteSpace: "nowrap",
    //         overflow: "hidden",
    //         textOverflow: "ellipsis",
    //         maxWidth: 250,
    //       }}
    //     />
    //   ),
    // },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (img) =>
        img?.startsWith("/9j/") ? (
          <img
            src={`data:image/jpeg;base64,${img}`}
            alt="blog"
            style={{
              width: 50,
              height: 50,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ) : img ? (
          <img
            src={img}
            alt="blog"
            style={{
              width: 50,
              height: 50,
              objectFit: "cover",
              borderRadius: 4,
            }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => (
        <div className="buttonGroup">
          <Button
            onClick={() => handleDrawerUpdate(record)}
            className="otherButtons edit"
          >
            <FaEdit />
          </Button>
          <Popconfirm
            title="Are you sure to delete this blog?"
            onConfirm={() => removeProperty(record.id || record.blog_id)}
            okText="Yes"
            cancelText="No"
          >
            <Button className="otherButtons deactive">
              <FaTrashAlt />
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const fetchData = async (page, limit) => {
    try {
      setLoading(true);
      const resp = await axios.get("https://skdm.in/server/sdg/blogs.php");
      console.log("Fetch API response:", resp);

      if (resp?.data?.data) {
        const processedData = resp.data.data.map((val) => ({
          ...val,
          created_at: moment(val.created_at).format("DD MMM YYYY, h:mm A"),
        }));
        setFetchList(processedData);
        setTotalData(processedData.length);
      } else {
        setFetchList([]);
        setTotalData(0);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      message.error("Failed to fetch blogs.");
      setFetchList([]);
      setTotalData(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const debounce = setTimeout(() => {
      fetchData(pageComp, limitComp);
    }, 300);
    return () => clearTimeout(debounce);
  }, [limitComp, pageComp]);

  const handleDrawerAdd = () => {
    setDrawerData({
      ...drawerData,
      isOpen: true,
      type: "blogAdd",
      title: "Add New Blog",
      data: null,
      onSuccess: () => fetchData(pageComp, limitComp),
    });
  };

  return (
    <div>
      <TitleComp
        name="Blog"
        type="Blog"
        totalData={totalData}
        isShowButton={true}
        handleDrawerAdd={handleDrawerAdd}
      />

      <TableComp
        data={fetchList}
        columns={columns}
        limitComp={limitComp}
        pageComp={pageComp}
        setPageComp={setPageComp}
        totalData={totalData}
        setLimitComp={setLimitComp}
        loading={loading}
        isShowFilter={false}
        fetchData={fetchData}
      />

      <DrawerComp />
    </div>
  );
}